export default __webpack_public_path__ + "static/media/upload_icon.78e0e884.svg";